
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'SellerOrdersHeader'
})
export default class extends Vue {
}
